import React, { useRef, useEffect, Suspense } from "react";
import Loader from "../../Components/UI/Loader";
import { TailSpin } from "react-loader-spinner";
import { primaryColor } from "../../Utils/Constant";
import { Button } from "@material-tailwind/react";
import { ArrowUpIcon } from "@heroicons/react/24/solid";
import { useQueryClient } from "@tanstack/react-query";

const InfiniteScroll = ({
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
  isLoading,
  children,
  inverse = false,
  hasNewData = false,
  refetch = () => {},
  queryKey,
}) => {
  const observerRef = useRef();
  const scrollTopRef = useRef();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!hasNextPage || isFetchingNextPage) return;

    const targetElement = observerRef.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          fetchNextPage(); // Fetch next page when in view
        }
      },
      { threshold: 0.2 }
    );

    if (targetElement) observer.observe(targetElement);

    return () => {
      if (targetElement) observer.unobserve(targetElement);
    };
  }, [fetchNextPage, hasNextPage, isFetchingNextPage]);

  const handleRefetch = async () => {
    queryClient.removeQueries({
      queryKey: queryKey,
    });
    const response = await refetch();
    if (scrollTopRef && response?.status === "success") {
      scrollTopRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <Suspense fallback={<Loader />}>
        <div className="h-0 w-0" ref={scrollTopRef} />

        {inverse && (
          <div
            ref={observerRef}
            className="flex w-full items-center justify-center p-2 shrink-0"
          >
            {isFetchingNextPage ? (
              <div className="flex w-full gap-3 items-center justify-center ">
                <TailSpin
                  visible={true}
                  height={"30px"}
                  width={"20px"}
                  strokeWidth={3}
                  ariaLabel="tail-spin-loading"
                  radius="1"
                  wrapperStyle={{}}
                  color={primaryColor}
                  wrapperClass=""
                />{" "}
                <span className="text-secondary font-semibold">
                  Loading more...
                </span>
              </div>
            ) : null}
          </div>
        )}
        {children}
        {!inverse && (
          <div
            ref={observerRef}
            className="flex w-full items-center justify-center p-2 shrink-0"
          >
            {isFetchingNextPage ? (
              <div className="flex w-full gap-3 items-center justify-center ">
                <TailSpin
                  visible={true}
                  height={"30px"}
                  width={"20px"}
                  strokeWidth={3}
                  ariaLabel="tail-spin-loading"
                  radius="1"
                  wrapperStyle={{}}
                  color={primaryColor}
                  wrapperClass=""
                />{" "}
                <span className="text-secondary font-semibold">
                  Loading more...
                </span>
              </div>
            ) : null}
          </div>
        )}
        {hasNewData && (
          <div className="absolute md:right-36  md:bottom-6 bottom-4 transform mx-auto right-1/2 translate-x-1/2 md:translate-x-0 flex justify-center">
            <Button
              variant="filled"
              loading={isLoading}
              className="rounded-3xl py-2 px-4 bg-transparent shadow-none hover:bg-primary text-debatePalette-title flex items-center gap-2"
              onClick={handleRefetch}
            >
              <span className="font-semibold text-base">Latest</span>
              <ArrowUpIcon
                className="w-4 h-4 font-semibold stroke-2"
                strokeWidth={10}
              />{" "}
            </Button>
          </div>
        )}
      </Suspense>
    </>
  );
};

export default InfiniteScroll;

// import React, { useRef, useEffect, Suspense } from "react";
// import Loader from "../../Components/UI/Loader";
// import { TailSpin } from "react-loader-spinner";

// const InfiniteScroll = ({
//   fetchNextPage,
//   hasNextPage,
//   isFetchingNextPage,
//   isLoading,
//   children,
//   inverse = false,
// }) => {
//   const observerRef = useRef();

//   useEffect(() => {
//     if (!hasNextPage || isFetchingNextPage) return;

//     const targetElement = observerRef.current;

//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           fetchNextPage(); // Fetch next page when in view
//         }
//       },
//       { threshold: 0.2 }
//     );

//     if (targetElement) observer.observe(targetElement);

//     return () => {
//       if (targetElement) observer.unobserve(targetElement);
//     };
//   }, [fetchNextPage, hasNextPage, isFetchingNextPage]);

//   return (
//     <>
//       <Suspense fallback={<Loader />}>
//         {inverse && (
//           <div
//             ref={observerRef}
//             className="flex w-full items-center justify-center p-2 shrink-0"
//           >
//             {isFetchingNextPage ? (
//               <div className="flex w-full gap-3 items-center justify-center ">
//                 <TailSpin
//                   visible={true}
//                   height={"30px"}
//                   width={"20px"}
//                   strokeWidth={3}
//                   ariaLabel="tail-spin-loading"
//                   radius="1"
//                   wrapperStyle={{}}
//                   color=primaryColor
//                   wrapperClass=""
//                 />{" "}
//                 <span className="text-secondary font-semibold">
//                   Loading more...
//                 </span>
//               </div>
//             ) : null}
//           </div>
//         )}
//         {children}
//         {!inverse && (
//           <div
//             ref={observerRef}
//             className="flex w-full items-center justify-center p-2 shrink-0"
//           >
//             {isFetchingNextPage ? (
//               <div className="flex w-full gap-3 items-center justify-center ">
//                 <TailSpin
//                   visible={true}
//                   height={"30px"}
//                   width={"20px"}
//                   strokeWidth={3}
//                   ariaLabel="tail-spin-loading"
//                   radius="1"
//                   wrapperStyle={{}}
//                   color=primaryColor
//                   wrapperClass=""
//                 />{" "}
//                 <span className="text-secondary font-semibold">
//                   Loading more...
//                 </span>
//               </div>
//             ) : null}
//           </div>
//         )}
//       </Suspense>
//     </>
//   );
// };

// export default InfiniteScroll;
